import { uniq } from "lodash";

import useQueryState from "./useQueryState";

function useWordList(field, defaultValue) {
	const [_wordList, setWordList] = useQueryState(field, defaultValue ?? []);
	const wordList = _wordList
		? Array.isArray(_wordList)
			? _wordList
			: [_wordList]
		: [];
	const addToWordList = (word) => setWordList((list) => uniq([...list, word]));
	const removeFromWordList = (word) =>
		setWordList((list) => list.filter((w) => w !== word));

	return [wordList, addToWordList, removeFromWordList];
}

export default useWordList;
